var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 89,
    viewBox: "0 0 75 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1326 78.2609C48.6848 83.8859 43.5782 88.0435 37.5 88.0435C31.4217 88.0435 26.3152 83.8859 24.8674 78.2609H50.1326Z",
    fill: "#CACEAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8332 66.2967C69.9522 65.0364 65.2174 60.8951 65.2174 47.2826V32.6087C65.2174 19.875 56.0886 9.28696 44.0217 6.9962L42.3913 6.68641C42.3913 5.79457 42.3913 5.31196 42.3913 4.8913C42.3913 2.18967 40.2016 0 37.5 0C34.7984 0 32.6087 2.18967 32.6087 4.8913V6.68641L30.9783 6.9962C18.9114 9.28696 9.78261 19.875 9.78261 32.6087V47.2826C9.78261 60.8951 5.04783 65.0364 2.16685 66.2967C0.834783 66.8788 0 68.2109 0 69.6636C0 71.7098 1.65978 73.3696 3.70598 73.3696H71.2924C73.3402 73.3696 75 71.7098 75 69.6636C75 68.2109 74.1652 66.8788 72.8332 66.2967V66.2967Z",
    fill: "#CACEAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundNotification);
export default __webpack_public_path__ + "static/media/soundNotification.ac013448f25a136f84462f7457463025.svg";
export { ForwardRef as ReactComponent };